//
//  Action Constants
//

export const Actions = {
    SHOW_CONFIRMATION: 'SHOW_CONFIRMATION',
    HIDE_CONFIRMATION: 'HIDE_CONFIRMATION',

    CONFIRM_YES: 'CONFIRM_YES',
    CONFIRM_NO: 'CONFIRM_NO',

    ESCAPE: 'ESCAPE',

    SET_LANGUAGE: 'SET_LANGUAGE',

    STORE_LOGIN_URL: 'STORE_LOGIN_URL',
};

export const showConfirmation = (msg: string) => ({
    type: Actions.SHOW_CONFIRMATION,
    payload: msg,
});
export const hideConfirmation = () => ({
    type: Actions.HIDE_CONFIRMATION,
});

export const confirmYes = () => ({
    type: Actions.CONFIRM_YES,
});
export const confirmNo = () => ({
    type: Actions.CONFIRM_NO,
});

export const escape = () => ({
    type: Actions.ESCAPE,
});

export const setLanguage = (langCode: string) => ({
    type: Actions.SET_LANGUAGE,
    payload: langCode,
});

export const storeLoginUrl = (url: string) => ({
    type: Actions.STORE_LOGIN_URL,
    payload: url,
});
